import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";

function Block5() {

    return (
            <section className="cta-home21-1 bgc-home21 homepage layout-pt-40 layout-pb-40" style={{background: "#F5F9FE"}}>
                <div className="auto-container">
                    <div className="row align-items-center">

                        <div className="content-column col-md-6 col-lg-5 offset-lg-1 order-2">
                            <div className="inner-column wow fadeInRight pt-0">
                                <div className="sec-title mb-4">
                                    <h2 className="homepage mb35">Votre plateforme webinaires <span>clé en main</span></h2>
                                    <div className="text homepage left">
                                        Une plateforme sur mesure, <b>entièrement personnalisable à vos couleurs,
                                        vos messages et vos visuels,</b> pour un service qui vous ressemble.
                                        <br/>
                                        <b>Fonctionnalités :</b>
                                    </div>
                                    <ul className="list-style-two at-home19 homepage mt20">
                                        <li>Page d’accueil personnalisée</li>
                                        <li>Programme des webinaires</li>
                                        <li>Inscriptions en ligne</li>
                                        <li>Accès aux replays</li>
                                        <li>Mise en avant de vos engagements et actions</li>
                                        <li>Espace ressources post-webinaire</li>
                                    </ul>
                                </div>
                                <ContactModal textButton="Contactez-nous et disposez de votre
                                    Webinaires Handicap" showText={false} small="small" linkPageContact={false} iframe={false} couleur={false} formModal={true}/>
                            </div>
                        </div>


                        <div className="image-column col-md-6 col-lg-6 mb-4 mb-lg-0">
                            <figure className="image-box wow fadeInLeft mx-0">
                                <img src="/images/resource/collage.webp" alt="politique-handicap" className="homepage"/>
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default Block5;
